import { gql } from "@apollo/client";

export const GET_ROLES = gql`
  query GetRoles($limit: Int = 10, $offset: Int = 0, $buildingId: uuid) {
    Role(
      where: {
        isActive: { _eq: true }
        _and: { BuildingId: { _eq: $buildingId } }
      }
      limit: $limit
      offset: $offset
    ) {
      Id
      Indoors
      IsChargingStation
      Lat
      Lng
      Title
      Type
      created_at
      isActive
      updated_at
    }
    Role_aggregate(where: { isActive: { _eq: true } }) {
      aggregate {
        count
      }
    }
  }
`;

export const GET_ROLE_CHECKLISTS = gql`
  query GetRoleChecklists($buildingId: uuid) {
    POI(
      where: {
        IsActive: { _eq: true }
        _and: { BuildingId: { _eq: $buildingId } }
      }
    ) {
      BuildingId
      Description
      Id
      IsActive
      Lat
      Long
      created_at
      floorId
      macAddress
      updated_at
      virtual
    }
    Task(
      where: {
        BuildingId: { _eq: $buildingId }
        _and: { isActive: { _eq: true } }
      }
    ) {
      BuildingId
      Description
      Id
      Name
      isActive
      updated_at
      created_at
      Priority
      IdealCompletionTime
    }
  }
`;

export const INSERT_ROLE = gql`
  mutation InsertRole(
    $BuildingId: uuid
    $ColourCode: String
    $Indoors: Boolean = false
    $IsChargingStation: Boolean = false
    $Lat: float8
    $Lng: float8
    $Title: String
    $Type: String
    $floorId: bigint
    $rolePois: [RolePOI_insert_input!]!
    $roleTaskSends: [RoleTaskSend_insert_input!]!
    $roleTaskStarts: [RoleTaskStart_insert_input!]!
  ) {
    insert_Role(
      objects: {
        BuildingId: $BuildingId
        ColourCode: $ColourCode
        Indoors: $Indoors
        IsChargingStation: $IsChargingStation
        Lat: $Lat
        Lng: $Lng
        Title: $Title
        Type: $Type
        floorId: $floorId
        isActive: true
        RolePOIs: {
          data: $rolePois
          on_conflict: { constraint: RolePOI_pkey, update_columns: [IsActive] }
        }
        RoleTaskSends: {
          data: $roleTaskSends
          on_conflict: {
            constraint: RoleTaskSend_pkey
            update_columns: [isActive]
          }
        }
        RoleTaskStarts: {
          data: $roleTaskStarts
          on_conflict: {
            constraint: RoleTaskStart_pkey
            update_columns: [isActive]
          }
        }
      }
      on_conflict: {
        constraint: Role_pkey
        update_columns: [isActive, floorId, Type, Title, Lat, Lng, Indoors]
      }
    ) {
      affected_rows
    }
  }
`;


export const GET_PATROLS = gql`
  query GetPatrols($limit: Int = 10, $offset: Int = 10, $buildingId: uuid) {
    RoleInstance(
      limit: $limit
      offset: $offset
      where: {
        Role: {
          BuildingId: { _eq: $buildingId }
          _and: { Type: { _eq: "Patrol" } }
        }
      }
      order_by: { timeStart: desc }
    ) {
      Id
      DateTimeEnd
      Shift_Gaurd {
        Gaurd {
          GaurdFirstName
        }
      }
      timeStart
      steps
      Role {
        Title
      }
    }
    RoleInstance_aggregate {
      aggregate {
        count
      }
    }
  }
`;